import { useEffect, useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { manageSignup } from '../../actions/auth-actions';
import { Box, Flex } from '@chakra-ui/react';
import LaunchdeckButton from '../../../global/components/helper-components/components/LaunchdeckButton';
import { validateEmail } from '../../../global/helpers/global-helpers';
import LaunchdeckFormInput from '../../../forms/TextInputField/components/LaunchdeckFormInput';
import { getCookieValue } from '../../../global/helpers/cookie-helpers';
import config from "../../../../config/app-config";


function SignupForm({
	prepopEmailDisplay,
	prepopNameDisplay,
	setShowSignupLoader,
	userProvidedInvalidEmail,
	userAcquisitionMethod,
	// Actions
	manageSignup,
}) {
	// const attributionCode = manageDsrUrlTags('atb')

	const [emailInput, setEmailInput] = useState("")
	const [nameInput, setNameInput] = useState("")

	const [isInvalidEmail, setIsInvalidEmail] = useState(false)
	const [isEmptyName, setIsEmptyName] = useState(false)

	useEffect(() => {
		if (prepopEmailDisplay) {
			setEmailInput(prepopEmailDisplay)
		}
	}, [prepopEmailDisplay]);


	useEffect(() => {
		if (prepopNameDisplay) {
			setNameInput(prepopNameDisplay)
		}
	}, [prepopNameDisplay]);

	useEffect(() => {
		if (userProvidedInvalidEmail) {

			setShowSignupLoader(false)
			setIsInvalidEmail(true)
		}
	}, [userProvidedInvalidEmail]);


	

		// useEffect(() => {
		// 	if (attributionCode) {
		// 		setLaunchdeckAffiliationCookie(attributionCode)
		// 	}
		// }, [attributionCode]);

	const handleChange = (event) => {

		if (event.target.name === "emailInput") {
			setEmailInput(event.target.value)
			!!isInvalidEmail && setIsInvalidEmail(false)
		} else if (event.target.name === "nameInput") {
			setNameInput(event.target.value)
			!!isEmptyName && setIsEmptyName(false)
		}
	}


	const createNewSignupUser = () => {
		const { signupAttributionCookieName } = config;
		const isValidEmail = validateEmail(emailInput.trim());
		const attributionCode = getCookieValue(signupAttributionCookieName)
		
		// const params = new URLSearchParams(window.location.search);
		// const referralCode = params.has('ref') ? params.get('ref') : ''; 

		if (!!isValidEmail && !!nameInput?.trim()) {
			setShowSignupLoader(true)

			manageSignup({
				event: 'create-signup-user',
				payload: {
					newUserEmail: emailInput.trim(),
					newUserName: nameInput,
					userAcquisitionMethod: userAcquisitionMethod || "Sign up page",
					attributionCode: attributionCode || ""
				}
			})
		} else {
			if (!nameInput.trim()) {
				setIsEmptyName(true)
			}

			if (!isValidEmail) {
				setIsInvalidEmail(true)
			}
		}
	}
	
	return (
		<Flex maxW='350px' mx='auto' align='flex-start' h='100%'>
			<Flex direction='column' align='center' my='2em' w='100%' gap='1em'>
				<Box w='100%' textAlign='left' mb='2em'>
					<Box fontSize='1em' fontWeight='600' letterSpacing='1px' color='brandDark.500' textAlign='left'>SIGN UP</Box>
				</Box>

				<LaunchdeckFormInput
					label='Email'
					name={'emailInput'}
					onChange={handleChange}
					value={emailInput}
					placeholder="email@mycompany.com"
					isRequired={true}

					errorLogic={isInvalidEmail}
					errorMessage={`Please use a valid email address`}
				/>

				<LaunchdeckFormInput
					label='Your name'
					name={'nameInput'}
					onChange={handleChange}
					value={nameInput}
					// placeholder="email@mycompany.com"
					isRequired={true}

					errorLogic={isEmptyName}
					errorMessage={`Please help us address you`}
				/>

				<Box />

				<Flex w='100%' direction='column' mt='1em' justify='center' alignItems='center'>
					<Flex w='100%'>
						<LaunchdeckButton bg='brand.500' color='white' w='100%' onClick={() => createNewSignupUser()} label='Create Launchdeck account' />
					</Flex>
				</Flex>
			</Flex>
		</Flex>
	);
};


const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			manageSignup
		},
		dispatch,
	)


export default connect(null, mapDispatchToProps)(SignupForm);
